export default "__VITE_ASSET__COa0GYpR__"